"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectTag = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectTag = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectTag, _super);
    function IkeObjectTag() {
        var _this = _super.call(this) || this;
        _this.className = 'Tag';
        _this.actionName = 'tag';
        _this.cacheKeys['uuid'] = true;
        return _this;
    }
    return IkeObjectTag;
}(base_1.IkeRestObject));
exports.IkeObjectTag = IkeObjectTag;
//# sourceMappingURL=tag.object.js.map